// Angular
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
// Auth
import { AlertNoticeService } from "../../../../core/alert/alert.service";
// Service
import { AuthService } from "../../../../core/services/auth.service";

@Component({
  selector: "kt-change-password",
  templateUrl: "./change-password.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class ChangePasswordComponent implements OnInit {
  // Public params
  forgotPasswordForm: FormGroup;
  loading = false;
  hide1 = true;
  hide2 = true;
  token: string;
  showAlert = false;

  constructor(private auth: AuthService, public authNoticeService: AlertNoticeService, private router: Router, private routerParam: ActivatedRoute, private fb: FormBuilder, private cdr: ChangeDetectorRef) {}

  /**
   * On init
   */
  ngOnInit() {
    this.token = this.routerParam.snapshot.params["token"];
    this.initRegistrationForm();
  }

  /**
   * Form initalization
   * Default params, validators
   */
  initRegistrationForm() {
    this.forgotPasswordForm = this.fb.group({
      password: ["", Validators.compose([Validators.required, Validators.pattern("(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}")])],
      confirmPassword: ["", Validators.compose([Validators.required, Validators.pattern("(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}")])],
    });
  }

  /**
   * Form Submit
   */
  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      if (form.value.password == form.value.confirmPassword) {
        const data = {
          pass: form.value.password,
          passnew: form.value.confirmPassword,
        };
        this.auth.changePassword(data, this.token).subscribe(
          (_res) => {
            this.loading = false;
            this.authNoticeService.setNotice("Se ha cambiado la contraseña exitosamente", "success");
            this.showAlert = true;
            setTimeout(() => this.router.navigateByUrl("/auth/login"), 5000);
            this.cdr.markForCheck();
          },
          (_err) => {
            const { error } = _err;
            const { errors } = error;
            this.loading = false;
            this.authNoticeService.setNotice(errors[0].defaultMessage, "danger");
            this.showAlert = true;
            this.cdr.markForCheck();
          }
        );
      } else {
        this.loading = false;
        this.authNoticeService.setNotice("Las contraseñas deben coincidir", "danger");
        this.showAlert = true;
        this.cdr.markForCheck();
      }
    } else {
      this.loading = false;
      Object.keys(form.controls).forEach((controlName) => form.controls[controlName].markAsTouched());
      return;
    }
  }

  /**
   * Checking control validation
   *
   * @param controlName: string => Equals to formControlName
   * @param validationType: string => Equals to valitors name
   */
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.forgotPasswordForm.controls[controlName];
    if (!control) {
      return false;
    }
    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }
}
